import trackingInstance from "./_tracking/Tracking";
import TRACKING_EVENTS from "./_tracking/trackingEvents";
import { API_URL } from "./const";

// Seconds to HMS
export const secondsToHms = (seconds, includeSeconds = true) => {
    seconds = Number(seconds);
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor((seconds % 3600) % 60);
    const hDisplay = h > 0 ? h + "hr " : "";
    const mDisplay = m > 0 ? m + "min " : "";
    const sDisplay = includeSeconds && s > 0 ? s + "sec" : "";
    return hDisplay + mDisplay + sDisplay;
};

// Get signup URL
export const getSignUpUrl = () => {
    return API_URL + `/accounts/signup/?next=${window.location.href}`;
};

// Get login URL
export const getLoginUrl = () => {
    return API_URL + `/accounts/login/?next=${window.location.href}`;
};

// Get logout URL
export const getLogoutUrl = () => {
    return API_URL + `/accounts/logout/?next=${window.location.href}`;
};

// Redirect to signup
export const redirectToSignUp = (trackingData = {}) => {
    trackingInstance.trackEvent(TRACKING_EVENTS.BUTTON_CLICK, {
        ...trackingData,
        event_label: "sign_up"
    });
    window.location.href = getSignUpUrl();
    return;
};

// Redirect to login
export const redirectToLogin = (trackingData = {}) => {
    trackingInstance.trackEvent(TRACKING_EVENTS.BUTTON_CLICK, {
        ...trackingData,
        event_label: "login"
    });
    window.location.href = getLoginUrl();
    return;
};

// Redirect to logout
export const redirectToLogout = (trackingData = {}) => {
    trackingInstance.trackEvent(TRACKING_EVENTS.BUTTON_CLICK, {
        ...trackingData,
        event_label: "logout"
    });
    window.location.href = getLogoutUrl();
    return;
};
